import { LinkButton } from '@cian/ui-kit';
import { VALIDATOR_URL } from '../../constants/url/validatorURL';
import * as styles from './ValidatorButton.css';

export const ValidatorButton = () => (
  <div className={styles['container']}>
    <LinkButton href={VALIDATOR_URL} size="XS" theme="fill_secondary" target="_blank" rel="noopener noreferrer">
      Перейти в валидатор
    </LinkButton>
  </div>
);
